module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-2.0ed59320.svg";